/**
 * Class description
 *
 * Created: 2017-11-17
 * @author jonas
 */

import {AssetQualityLevel, IResourcesGroupConfig} from "@nolimitcity/slot-game/bin/core/resource/asset/Asset";
import {BitmapFontAsset} from "@nolimitcity/slot-game/bin/core/resource/asset/assettypes/BitmapFontAsset";
import {SpineAsset} from "@nolimitcity/slot-game/bin/core/resource/asset/assettypes/SpineAsset";
import {TextureAsset} from "@nolimitcity/slot-game/bin/core/resource/asset/assettypes/TextureAsset";

export class FruitsGameAssets {

    public static MAIN_GAME_BACKGROUND_LANDSCAPE:string = "main_landscape_background";
    public static MAIN_GAME_BACKGROUND_PORTRAIT:string = "main_portrait_background";

    public static BONUS_GAME_BACKGROUND_LANDSCAPE:string = "bonus_landscape_background";
    public static BONUS_GAME_BACKGROUND_PORTRAIT:string = "bonus_portrait_background";

    // Intro
    public static IS_FEATURE_1:string = "IS_Feature_1";
    public static IS_FEATURE_2:string = "IS_Feature_2";
    public static IS_FEATURE_3:string = "IS_Feature_3";

    public static BONUS_B:string = "Bonus_Game/Bonus_B";
    public static BONUS_BG_LANDSCAPE:string = "Bonus_Game/Bonus_BG";
    public static BONUS_BG_LANDSCAPE_REV:string = "Bonus_Game/Bonus_BG_rev";
    public static BONUS_BG_PORTRAIT:string = "Bonus_Game/Bonus_BG_Portrait";
    public static BONUS_A:string = "Bonus_A";
    public static BONUS_C:string = "Bonus_C";


    // BIG WIN
    public static BW_SBERRY_SEQ:string = "big_win/Sberry_SEQ/Sberry_";
    public static BW_GRAPE_SEQ:string = "big_win/Grape_SEQ/Grape_";
    public static BW_STAR_SEQ:string = "big_win/Star_SEQ/StarSeq_";

    public static getBGTexture(level:string):string {
        return `big_win/BG_${level}`
    }

    public static RESOURCES_GROUPS:IResourcesGroupConfig = {
        intro : [
            {
                name : "introJpeg",
                assets : [
                    new TextureAsset("introJpeg0", "sheets/introJpeg/introJpeg0.json"),
                    new TextureAsset("introJpeg1", "sheets/introJpeg/introJpeg1.json"),
                    new TextureAsset("introJpeg2", "sheets/introJpeg/introJpeg2.json"),
                    new TextureAsset("introJpeg3", "sheets/introJpeg/introJpeg3.json"),

                ]
            },
            {
                name : "intro",
                autoLoad : [AssetQualityLevel.HIGH],
                assets : [
                    new TextureAsset("intro0", "sheets/intro/intro0.json"),
                ],
                animations : {
                    "logo" : "Logo",
                    "Respin_A" : "Respin_A",
                    "Respin_B" : "Respin_B",
                    "logoSticky" : "Logo_Sticky",
                    "logoBonus" : "Logo_Bonus",
                }
            },
            {
                name : "fonts",
                assets : [
                    new BitmapFontAsset("NumbersOpenSans800", "fonts/bitmapfonts/NumbersOpenSans800.fnt"),
                    new BitmapFontAsset("WinNumbersBM", "fonts/bitmapfonts/WinNumbersBM.fnt"),
                    new BitmapFontAsset("Win_Numbers_A", "fonts/bitmapfonts/Win_Numbers_A.fnt"),
                    new BitmapFontAsset("Win_Numbers_B", "fonts/bitmapfonts/Win_Numbers_B.fnt"),
                    new BitmapFontAsset("Win_Numbers_C", "fonts/bitmapfonts/Win_Numbers_C.fnt"),
                    new BitmapFontAsset("Win_Numbers_D", "fonts/bitmapfonts/Win_Numbers_D.fnt"),
                ]
            },
            {
                name : "spine",
                assets : [
                    new SpineAsset("spineBackgroundIdle", "spine/FXIdle.json"),
                    new SpineAsset("spineBackgroundIdlePortrait", "spine/FX_IdlePortrait.json"),
                    new SpineAsset("spineSymbolIdle", "spine/IdleFXSYM.json"),
                ]
            },

        ],

        main : [
            {
                name : "main",
                assets : [
                    new TextureAsset("main0", "sheets/main/main0.json"),
                    new TextureAsset("main1", "sheets/main/main1.json"),
                    new TextureAsset("main2", "sheets/main/main2.json"),
                    new TextureAsset("main3", "sheets/main/main3.json"),
                    new TextureAsset("mainJpeg0", "sheets/mainJpeg/mainJpeg0.json"),
                    new TextureAsset("mainJpeg1", "sheets/mainJpeg/mainJpeg1.json"),
                    new TextureAsset("mainJpeg2", "sheets/mainJpeg/mainJpeg2.json"),
                    new TextureAsset("mainJpeg3", "sheets/mainJpeg/mainJpeg3.json"),
                    new TextureAsset("mainJpeg4", "sheets/mainJpeg/mainJpeg4.json"),
                    new TextureAsset("mainJpeg5", "sheets/mainJpeg/mainJpeg5.json"),
                ],
                animations : {
                    "ReelBgX2" : "Reels_Add",
                    "ReelBgX4" : "Reels_Main",
                    "reelViewMask" : "reelViewMask",
                    "stars" : "Stars/Win_FX_StarSplash_",
                    "winFXSplash" : "Win_FX_Splash",
                    "sym_Mystery" : "Sym_Mystery",
                    "mystery_fx_appear" : "FX_Mystery_Appear/FX_Mystery_Appear_",
                    "mystery_fx_disappear" : "FX_Mystery_Disappear/FX_Disappear_",
                    "singleReelBG_A" : "Reels_SlotA",
                    "indicatorBG" : "Indicator/Indicator_bg",
                    "indicatorBG_A" : "Indicator/Indicator_bgA",
                    "indicatorBG_B" : "Indicator/Indicator_bgB",
                    "indicatorBG_C" : "Indicator/Indicator_bgC",
                    "indicatorBG_D" : "Indicator/Indicator_bgD",
                    "indicatorActive" : "Indicator/Indicator_sym_active",
                    "indicatorDisabled" : "Indicator/Indicator_sym_dis",
                    "indicatorEnabled" : "Indicator/Indicator_sym_ena",
                    "indicatorRays" : "FX_Rays",
                    "scatterAttentionAnim_A" : "Bonus_Scatter_Attention/A/S_A_Attention_",
                    "scatterAttentionAnim_B" : "Bonus_Scatter_Attention/B/S_B_Attention_",
                    "scatterAttentionAnim_C" : "Bonus_Scatter_Attention/C/S_C_Attention_",
                    "scatterAttentionAnim_D" : "Bonus_Scatter_Attention/D/S_D_Attention_",
                    "scatterBoltAnimation" : "Bonus_Scatter_Attention/SYM_S_Wiggle/SYM_S_Attention_Wiggle_",
                    "scatterB" : "S_B/S_B",
                    "scatterC" : "S_C/S_C",
                    "scatterD" : "S_D/S_D",
                    "s_Landing_A" : "W_Landing/SYM_W_Land_",
                    "S_B_win" : "Wild_Win_B/Sym_S_WinB_",
                    "S_C_win" : "Wild_Win_C/Sym_S_WinC_",
                    "S_D_win" : "Wild_Win_D/Sym_S_WinD_",
                    "W_land" : "W_Landing/SYM_W_Land_",
                    "Star_Intro" : "Star_Intro/Star_Intro_",
                    "Bonus_B_Gloss" : "Bonus_B_Gloss/Bonus_B_Gloss_",
                    "StickyFxSplash": "sticky/Sticky_FX_Splash/FX_StickySplash_",
                    "FX_Rainbow": "FX_Rainbow/Fx_Rainbow_",
                    "FX_Stars": "sticky/FX_Stars",
                    "Sticky_BG": "sticky/Sym_Sticky_BG",
                    "Bg_Rays": "stickyJpeg/Bg_Rays",
                    "B1_Element" : "Bonus_Game/B1_Element",
                    "scatter_text_bg" : "Bonus_Game/Bonus_Intro_txt_bg",
                    "B2_Element" : "Bonus_Game/B2_Element",
                    "scatterFrameAnim" : "FX_Scatter_Frame/FX_S_Frame_",
                    "excitementFX" : "FX_Excitement/FX_Excitement_",
                    "scatterFrame" : "Scatter_Frame",
                    "IdleFX_Reels" : "IdleFX_Reels/IdleFX_Reels_",
                    "bonusReelGloss" : "FX_BonusReelsGloss/FX_BonusReelsGloss_",
                }
            },
            {
                name : "symbols",
                autoLoad : [AssetQualityLevel.MEDIUM, AssetQualityLevel.HIGH],
                assets : [
                    new TextureAsset("symbols0", "sheets/symbols/symbols0.json"),
                    new TextureAsset("symbols1", "sheets/symbols/symbols1.json"),
                ],
                animations : {
                    L1_normal : "L1/L1",
                    L2_normal : "L2/L2",
                    L3_normal : "L3/L3",
                    L4_normal : "L4/L4",
                    M1_normal : "M1/M1",
                    M2_normal : "M2/M2",
                    M3_normal : "M3/M3",
                    M4_normal : "M4/M4",
                    M5_normal : "M5/M5",
                    M6_normal : "M6/M6",
                    S_normal : "S/S",
                    S_B_normal : "S_B/S_B",
                    S_C_normal : "S_C/S_C",
                    S_D_normal : "S_D/S_D",
                    W_normal : "W/W",
                    B1_normal : "B1/B1",
                    B2_normal : "B2/B2",
                    X_normal : "X/X",

                    L1_spin : "L1/L1_spin",
                    L2_spin : "L2/L2_spin",
                    L3_spin : "L3/L3_spin",
                    L4_spin : "L4/L4_spin",
                    M1_spin : "M1/M1_spin",
                    M2_spin : "M2/M2_spin",
                    M3_spin : "M3/M3_spin",
                    M4_spin : "M4/M4_spin",
                    M5_spin : "M5/M5_spin",
                    M6_spin : "M6/M6_spin",
                    S_spin : "S/S_spin",
                    S_B_spin : "S_B/S_B_spin",
                    S_C_spin : "S_C/S_C_spin",
                    S_D_spin : "S_D/S_D_spin",
                    W_spin : "W/W_spin",
                    B1_spin : "B1/B1_spin",
                    B2_spin : "B2/B2_spin",
                    X_spin : "X/X_spin",

                    L1_respin : "L1/L1_respin",
                    L2_respin : "L2/L2_respin",
                    L3_respin : "L3/L3_respin",
                    L4_respin : "L4/L4_respin",
                    M1_respin : "M1/M1_respin",
                    M2_respin : "M2/M2_respin",
                    M3_respin : "M3/M3_respin",
                    M4_respin : "M4/M4_respin",
                    M5_respin : "M5/M5_respin",
                    M6_respin : "M6/M6_respin",
                    W_respin : "W/W_respin",

                    L1_win : "L1/L1_win",
                    L2_win : "L2/L2_win",
                    L3_win : "L3/L3_win",
                    L4_win : "L4/L4_win",
                    M1_win : "M1/M1_win",
                    M2_win : "M2/M2_win",
                    M3_win : "M3/M3_win",
                    M4_win : "M4/M4_win",
                    M5_win : "M5/M5_win",
                    M6_win : "M6/M6_win",
                    B1_win : "B1/B1_Win/Sym_B1_Win_",
                    B2_win : "B2/B2_Win/Sym_B2_Win_",

                    S_win : "S/Scatter_Win/Sym_S_Win_",
                    W_win : "W/Wild_Win/SYM_W_Win",
                }
            }
        ]
    };
}
